module.exports = __webpack_public_path__ + "img/bandevideo.58ebad35.jpg";